import { Knob, Typography } from 'design_system/src';
import { LightTooltip } from 'components/hocs/tooltip/Tooltip';
import { formatDate } from 'models/shared/helpers/dates';
import {
	LeadSortValues,
	LeadStatus,
	LeadStatusValues,
	LeadStep,
	LeadStepValues,
	getLeadProgressPercentage,
} from 'models/lead/enums/lead.enums';
import { Lead } from 'models/lead/interfaces/lead.interface';

export const leadStepOptions = Object.entries(LeadStepValues).map(
	([value, title]) => ({ label: title, value }),
);

export const leadStatusOptions = Object.entries(LeadStatusValues).map(
	([value, { title }]) => ({ label: title, value }),
);

export const leadSortOptions = Object.entries(LeadSortValues).map(
	([value, { title }]) => ({ label: title, value }),
);

export const leadsListColumns = () => [
	{
		label: 'Correo',
		weight: 3,
		render: (row: Lead) => (
			<Typography scale="medium" weight="600" textColor="neutral_900">
				{row.email}
			</Typography>
		),
	},
	{
		label: 'nombre',
		weight: 3,
		render: (row: Lead) => {
			const fullName = [
				row.firstName,
				row.middleName,
				row.lastName,
				row.secondLastName,
			]
				.filter(Boolean)
				.join(' ');
			return (
				<Typography scale="medium" weight="400" textColor="neutral_700">
					{fullName || 'Sin nombre'}
				</Typography>
			);
		},
	},
	{
		label: 'CURP',
		weight: 3,
		render: (row: Lead) => (
			<Typography scale="medium" weight="400" textColor="neutral_900">
				{row.curp}
			</Typography>
		),
	},
	{
		label: 'progreso',
		weight: 1,
		render: (row: Lead) => {
			const percentage = getLeadProgressPercentage(row.step, row.status);
			return (
				<div className="display_flex flex_center flex_col flex_gap_xxs">
					{row.status === LeadStatus.completed &&
					row.step === LeadStep.financialInformationStep ? (
						<div />
					) : (
						<LightTooltip
							title={
								<Typography weight="400" scale="small">
									<strong>Paso actual:</strong>
									<br />
									<span>{LeadStepValues[row.step] ?? row.step}</span>
								</Typography>
							}
						>
							<div>
								<Knob
									value={percentage}
									symbol="%"
									className="dim_xxl border_transparent display_flex"
									color="green_300"
								/>
							</div>
						</LightTooltip>
					)}
				</div>
			);
		},
	},
	{
		label: 'status',
		weight: 1,
		render: (row: Lead) => (
			<Typography
				scale="xsmall"
				weight="600"
				className="text_center"
				textColor={LeadStatusValues[row.status]?.color ?? 'neutral_700'}
			>
				{LeadStatusValues[row.status]?.title ?? row.status}
			</Typography>
		),
	},
	{
		label: 'creado',
		weight: 1,
		render: (row: Lead) => (
			<Typography
				scale="small"
				weight="400"
				textColor="neutral_700"
				className="text_center"
			>
				{formatDate(row.createdAt)}
			</Typography>
		),
	},
	{
		label: 'actualizado',
		weight: 1,
		render: (row: Lead) => (
			<Typography
				scale="small"
				weight="400"
				textColor="neutral_700"
				className="text_center"
			>
				{formatDate(row.updatedAt)}
			</Typography>
		),
	},
];
